import { useMutation, useQueryClient } from "@tanstack/react-query";
import useAxios from "./useAxios";
import { toastError, toastSuccess } from "../utils/toastrResponse";

export const useMutateData = () => {
  const queryClient = useQueryClient();
  const  axiosInstance  = useAxios();
  let invalidateKey = "";
  let msg = "created successfully";

  const apiPostMutation = useMutation({
    mutationFn: async ({
      url,
      payload,
      queryKeyToInvalidate,
      successMessage,
      method,
      closeModal,
      step,
    }) => {
      invalidateKey = queryKeyToInvalidate;
      msg = successMessage;

      try {
        const response = await axiosInstance({
          url,
          method,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: payload,
        });

        if (response.status >= 200 && response.status < 300) {
          if (closeModal) closeModal(false);
          if (step) step(1);
          return response.data;
        } else {
          throw new Error("Failed to post data to the API");
        }
      } catch (error) {
        throw new Error(
          error.response?.data?.message ||
            error.message ||
            "Failed to post data to the API"
        );
      }
    },
    onSuccess: () => {
      // Invalidate and refetch the query after a successful mutation
      queryClient.invalidateQueries(invalidateKey);
      toastSuccess(msg);
    },
    onError: (error) => {
      toastError(error.message);
      console.log("Error thrown:", error);
    },
  });

  return apiPostMutation;
};
